import { JL } from "jsnlog";

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  const customAjaxAppender = JL.createAjaxAppender("customAjaxAppender");
  customAjaxAppender.setOptions?.({
    url: "/api/_/report",
  });

  const logger = JL(`StoriesApp-${runtimeConfig.app.version}`);
  logger.setOptions({ appenders: [customAjaxAppender] });

  return {
    provide: {
      logger,
    },
  };
});
